import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import { updateHub } from "../../../Redux/Slices/hubs.slice";
import PlugIcon from "../../../Common/Svgs/PlugIcon";

const options = [
  {
    id: 1,
    value: "Charging History",
    icon: (
      <PlugIcon size={16} className="text-dark-gray group-hover:text-black" />
    ),
  },
];

const ListDropdown = ({ detail }) => {
  const dispatch = useDispatch();

  const { threeDotsPopoverId } = useSelector((state) => state.hubs);

  const [open, setOpen] = useState(false);

  const onOptionClick = async (optionId) => {
    dispatch(
      updateHub({
        key: "currentCharger",
        value: detail,
      }),
    );

    setOpen(false);

    switch (optionId) {
      case 1:
        dispatch(
          updateHub({
            key: "historyDrawer",
            value: true,
          }),
        );
        break;
      default:
        break;
    }
  };

  const handleOpenChange = (state) => {
    setOpen(state);

    dispatch(
      updateHub({
        key: "threeDotsPopoverId",
        value: detail.id,
      }),
    );
  };

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open && threeDotsPopoverId === detail.id}
      arrow={false}
      onOpenChange={(state) => handleOpenChange(state)}
      content={
        <div
          className="rounded-md bg-background-white py-1"
          style={{
            width: "156px",
            boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.10)",
          }}
        >
          {options.map((option) => (
            <button
              type="button"
              className="w-full flex items-center gap-x-3 px-3 py-2 group hover:bg-background"
              key={option.id}
              onClick={() => onOptionClick(option.id)}
            >
              {option.icon}

              <p className="font-aileron text-xs font-semibold capitalize whitespace-nowrap text-dark-gray group-hover:text-black">
                {option.value}
              </p>
            </button>
          ))}
        </div>
      }
    >
      <div className="cursor-pointer">
        <img src="/assets/icons/trips/more.svg" alt="dropdown" />
      </div>
    </Popover>
  );
};

export default ListDropdown;
